"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _reactRouterDom = require("react-router-dom");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ConsoleShell = require("web/shared/console/ConsoleShell.styles");
var _consolePage = require("web/shared/console/consolePage.styles");
var _sidebarCollapsed = require("web/shared/console/sidebarCollapsed");
var _useDocumentTitle = _interopRequireDefault(require("web/shared/hooks/useDocumentTitle"));
var _useIsPhoneViewport = _interopRequireDefault(require("web/shared/hooks/useIsPhoneViewport"));
var _useViewportLock = _interopRequireWildcard(require("web/shared/hooks/useViewportLock"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _ShellIndexRows = _interopRequireDefault(require("web/shared/shell/ShellIndexRows"));
var _ShellIndexRows2 = require("web/shared/shell/ShellIndexRows.styles");
var _ShellNav = _interopRequireDefault(require("web/shared/shell/ShellNav"));
var _ShellNavHeading = _interopRequireDefault(require("web/shared/shell/ShellNavHeading"));
var _ShellNav2 = require("web/shared/shell/ShellNav.styles");
var _visuallyHidden = require("web/shared/styles/visuallyHidden");
var _shellDestinations = require("web/shared/shell/shellDestinations");
var _shell = require("web/shared/shell/shell.styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The console: the one frame around every tool, the same in every product.
* On a wide viewport it is the sidebar of tools at the left edge, foldable
* to a rail of glyphs, and the chosen tool in every column that is left;
* the two stand the full height the layout leaves and scroll on their own.
* The sidebar's tools scroll above the control that folds it, which stays
* at its foot.
* `/internal` itself opens the product's first tool. On a phone it is the
* index of tools at `/internal`, scrolling in the height the layout leaves,
* and every tool a screen of its own under a way back.
*
* The product's gate lives here once, around the whole frame; the tools
* read the layout's outlet context through this shell exactly as they
* would read it directly. A tool that scrolls inside itself says so
* through the viewport lock, and the pane hands its height down to it
* instead of scrolling. An action that is not a page — something done in
* place — is listed after the pages.
*/
const INTERNAL_PATH = "/internal"; // Something the console does in place rather than a page it opens.
function ConsoleShell(_ref) {
  let productName = _ref.productName,
    groups = _ref.groups,
    landingPath = _ref.landingPath,
    gate = _ref.gate,
    actions = _ref.actions;
  const outletContext = (0, _reactRouterDom.useOutletContext)();
  const location = (0, _reactRouterDom.useLocation)();
  const phone = (0, _useIsPhoneViewport.default)();
  const _useState = (0, _react.useState)(_sidebarCollapsed.sidebarCollapsed),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  const toggleCollapsed = () => {
    const next = !collapsed;
    setCollapsed(next);
    (0, _sidebarCollapsed.rememberSidebarCollapsed)(next);
  }; // The console owns the height the layout leaves: the sidebar and the
  // pane each scroll on their own inside it. A tool that fills the pane
  // and scrolls inside itself says so here, and the pane hands its height
  // down instead of scrolling.
  (0, _useViewportLock.default)();
  const _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    fills = _useState4[0],
    setFills = _useState4[1];
  const pathname = location.pathname.replace(/\/+$/, "") || "/";
  const atIndex = pathname === INTERNAL_PATH;
  const current = (0, _shellDestinations.destinationFor)(groups, pathname);
  (0, _useDocumentTitle.default)(atIndex || current == null ? "Internal \xB7 ".concat(productName) : "".concat(current.label, " \xB7 Internal \xB7 ").concat(productName));
  if (atIndex && !phone) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Navigate, {
      to: landingPath,
      replace: true
    });
  } // The console reports nothing about where its viewers go.
  const onNavigate = () => {};
  if (atIndex) {
    return gate(/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConsoleShell.styles.index, _consolePage.consolePage.inset, _consolePage.consolePage.roomBelow)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_shell.styles.title, _ConsoleShell.styles.indexTitle)), {}, {
        children: "Internal"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShellIndexRows.default, {
        groups: groups,
        trailingGroups: [],
        onNavigate: onNavigate
      }), actions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.group)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.heading)), {}, {
          children: "Tools"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.list)), {}, {
          children: actions.map(action => /*#__PURE__*/(0, _jsxRuntime.jsx)("li", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.item)), {}, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
              type: "button",
              onClick: () => {
                action.onSelect();
              }
            }, stylex.props(_ShellIndexRows2.styles.row, _ShellIndexRows2.styles.rowButton)), {}, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.glyph)), {}, {
                "aria-hidden": "true",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                  name: action.icon,
                  size: "m"
                })
              })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.text)), {}, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.label)), {}, {
                  children: action.label
                })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellIndexRows2.styles.description)), {}, {
                  children: action.description
                }))]
              }))]
            }))
          }), action.key))
        }))]
      })) : null]
    })));
  }
  return gate(/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConsoleShell.styles.frame)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h1", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_shell.styles.title, _visuallyHidden.visuallyHidden.text)), {}, {
      children: "Internal"
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConsoleShell.styles.columns)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConsoleShell.styles.sidebar, collapsed && _ConsoleShell.styles.sidebarCollapsed)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConsoleShell.styles.sidebarMenu)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShellNav.default, {
            label: "Internal",
            groups: groups,
            current: current,
            onNavigate: onNavigate,
            trailingGroups: [],
            collapsed: collapsed,
            foot: actions.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellNav2.styles.group, _ShellNav2.styles.groupAfterFirst, collapsed && _ShellNav2.styles.groupDivided)), {}, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ShellNavHeading.default, {
                text: "Tools",
                collapsed: collapsed
              }), actions.map(action => /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
                type: "button",
                "aria-label": collapsed ? action.label : undefined,
                title: collapsed ? action.label : undefined,
                onClick: () => {
                  action.onSelect();
                }
              }, stylex.props(_ShellNav2.styles.footButton, collapsed && _ShellNav2.styles.linkCollapsed)), {}, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                  name: action.icon,
                  size: "m"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ShellNav2.styles.label, collapsed && _ShellNav2.styles.labelHidden)), {}, {
                  children: action.label
                }))]
              }), action.key))]
            })) : null
          })
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          type: "button",
          "aria-label": collapsed ? "Expand sidebar" : "Collapse sidebar",
          "aria-expanded": !collapsed,
          title: collapsed ? "Expand sidebar" : "Collapse sidebar",
          onClick: toggleCollapsed
        }, stylex.props(_ConsoleShell.styles.foldButton)), {}, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: collapsed ? "chevron-right" : "chevron-left",
            size: "m"
          })
        }))]
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_ConsoleShell.styles.pane, fills ? _ConsoleShell.styles.paneHandsDown : _ConsoleShell.styles.paneScrolls)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactRouterDom.Link, (0, _objectSpread2.default)((0, _objectSpread2.default)({
          to: INTERNAL_PATH,
          "aria-label": "Back to Internal"
        }, stylex.props(_shell.styles.back, _shell.styles.phoneOnly, _ConsoleShell.styles.paneBack)), {}, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
            name: "chevron-left",
            size: "s"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: "Internal"
          })]
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_useViewportLock.ViewportLockContext.Provider, {
          value: setFills,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Outlet, {
            context: outletContext
          })
        })]
      }))]
    }))]
  })));
}
var _default = exports.default = ConsoleShell;